import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'
import VueFilter from 'vue-filter'
import VueUploader from "vue-uploader"

Vue.use(VueResource);
Vue.use(VueFilter);
Vue.use(VueUploader);
Vue.http.options.headers={
  'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'
};

/* eslint-disable no-new */
new Vue({
  el: 'body',
  components: { App }
});


// WEBPACK FOOTER //
// ./src/main.js